"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllowedChildTypes = void 0;
const tslib_1 = require("tslib");
const client_utils_1 = require("@sensenet/client-utils");
const ODataUrlBuilder_1 = require("./ODataUrlBuilder");
class AllowedChildTypes {
    constructor(repository) {
        this.repository = repository;
    }
    add(idOrPath, contentTypes) {
        return this.repository.executeAction({
            idOrPath,
            name: 'AddAllowedChildTypes',
            method: 'POST',
            body: {
                contentTypes,
            },
        });
    }
    update(idOrPath, contentTypes) {
        return this.repository.patch({
            idOrPath,
            content: {
                AllowedChildTypes: contentTypes,
            },
        });
    }
    remove(idOrPath, contentTypes) {
        return this.repository.executeAction({
            idOrPath,
            name: 'RemoveAllowedChildTypes',
            method: 'POST',
            body: {
                contentTypes,
            },
        });
    }
    getFromCTD(idOrPath) {
        return this.repository.executeAction({
            idOrPath,
            name: 'GetAllowedChildTypesFromCTD',
            method: 'GET',
            body: {
                select: ['Name', 'DisplayName', 'Icon'],
            },
        });
    }
    listEmpty(idOrPath) {
        return this.repository.executeAction({
            idOrPath,
            name: 'CheckAllowedChildTypesOfFolders',
            method: 'GET',
        });
    }
    /**
     * Retrieves an aggregated list of content types the user can create as children below the given content
     * @param {LoadOptions<ContentType>} options
     */
    get(options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const allowedTypes = { d: { __count: 0, results: [] } };
            yield Promise.all([this.getImplicit(options), this.getExplicit(options)]).then(([implicitACTs, explicitACTs]) => {
                allowedTypes.d.results = implicitACTs.d
                    ? implicitACTs.d.results
                        .filter((ct) => !explicitACTs.d.results.find((contenttype) => ct.Name === contenttype.Name))
                        .concat(explicitACTs.d.results)
                    : [];
                allowedTypes.d.__count = allowedTypes.d.results.length;
            });
            return allowedTypes;
        });
    }
    /**
     * Retrieves a list of content types the user can create as children below the given content (allowed on the content)
     * @param {LoadOptions<ContentType>} options Options for fetching the AllowedChildTypes
     */
    getImplicit(options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const contextPath = client_utils_1.PathHelper.getContentUrl(options.idOrPath);
            const params = ODataUrlBuilder_1.ODataUrlBuilder.buildUrlParamString(this.repository.configuration, options.oDataOptions);
            const path = client_utils_1.PathHelper.joinPaths(this.repository.configuration.repositoryUrl, this.repository.configuration.oDataToken, contextPath, 'AllowedChildTypes');
            const response = yield this.repository.fetch(`${path}?${params}`, {
                credentials: 'include',
                method: 'GET',
            });
            if (!response.ok) {
                throw yield this.repository.getErrorFromResponse(response);
            }
            return yield response.json();
        });
    }
    /**
     * Retrieves a list of content types the user can create as children below the given content (allowed in the CTD)
     * @param {LoadOptions<ContentType>} options Options for fetching the AllowedChildTypes
     */
    getExplicit(options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const contextPath = client_utils_1.PathHelper.getContentUrl(options.idOrPath);
            const params = ODataUrlBuilder_1.ODataUrlBuilder.buildUrlParamString(this.repository.configuration, options.oDataOptions);
            const path = client_utils_1.PathHelper.joinPaths(this.repository.configuration.repositoryUrl, this.repository.configuration.oDataToken, contextPath, 'EffectiveAllowedChildTypes');
            const response = yield this.repository.fetch(`${path}?${params}`, {
                credentials: 'include',
                method: 'GET',
            });
            if (!response.ok) {
                throw yield this.repository.getErrorFromResponse(response);
            }
            return yield response.json();
        });
    }
}
exports.AllowedChildTypes = AllowedChildTypes;
//# sourceMappingURL=AllowedChildTypes.js.map